export default function({ query, redirect }) {
  // console.log('certNo=', certNo)
  if (!query.certNo) {
    return redirect({ path: '/identify/guide', query })
  }
}
